<template>
  <div class="uk-animation-fade">
    <!-- cover image: -->
    <div class="image-container">
      <div class="wrapper">
        <img src="../assets/jpg/skyline.jpg" alt />
        <div class="text uk-visible@m">
          <span>
            kennis is macht,
            <br />maar enthousiasme zet alles in beweging
          </span>
        </div>
      </div>
    </div>

    <!-- cards: -->
    <div class="uk-container large card-container uk-padding-large">
      <div class="uk-grid-match uk-text-center" uk-grid>
        <div class="uk-width-1-3@l">
          <div class="uk-card uk-card-default uk-card-body">
            <h3 class="uk-card-title">Variërende werkzaamheden</h3>
            <p class="uk-text-justify">
              DNZ Projects is een leerbedrijf met verschillende specialiteiten in huis. De
              diensten die wij verlenen is alles tussen het aanleggen van industriele
              installaties tot aan het installeren van deurbellen. Je komt steeds op
              andere werkplekken: schepen, hallen, kantoren, ziekenhuizen, scholen,
              zwembaden, kazernes, noem het maar op. Elk project is weer anders en in elk
              project zul je weer andere technieken en vaardigheden moeten toepassen.
            </p>
            <h3 class="uk-card-title">leuk klimaat</h3>
            <p class="uk-text-justify">
              Werken Bij DNZ Projects is in een informele sfeer waarbij iedereen elkaar
              kent. Wij zijn altijd bereid om te kijken of we iets voor je kunnen doen.
              Wij behandelen iedereen zoals we zelf ook behandeld willen worden binnen ons
              bedrijf.
            </p>

            <h3 class="uk-card-title">verantwoording</h3>
            <p class="uk-text-justify">
              Bij DNZ Projects wordt er geluisterd naar je mening. Als je iets installeert
              neem je hier dan ook de verantwoording voor. Uiteraard kijken we samen hoe
              iets beter kan als het niet gelijk lekker gaat.
            </p>

            <!-- <span
              class="uk-text-center emphasis uk-text-middle"
            >Wij geven geen loze beloftes, maar echte daden!</span>-->
          </div>
        </div>
        <div class="uk-width-2-3@l">
          <div class="uk-card uk-card-default uk-card-body">
            <h3 class="uk-card-title">vacatures</h3>

            <div
              uk-grid
              class="uk-padding uk-padding-remove-left uk-padding-remove-right"
            >
              <div class="uk-width-1-2@m uk-width-1-1@s">
                <div style="margin-right: 4rem">
                  <!-- <el-collapse accordion>
                    <el-collapse-item title="vacatures voor op de vloer" name="2"> -->
                      <ul class="uk-list vacancie-list">
                        <!-- <span>momenteel zijn er geen open vacatures</span> -->
                        <li
                          @click="activeVacancyID = item.id"
                          v-for="item in vacancies"
                          :key="item.id"
                        >
                          <span v-if="item.plek === 'vloer'">{{ item.title }}</span>
                          <span
                            v-if="item.plek === 'vloer'"
                            class="icon uk-margin-left"
                            uk-icon="arrow-right"
                          ></span>
                        </li>
                      </ul>
                    <!-- </el-collapse-item>
                    <el-collapse-item title="vacatures voor op kantoor" name="1">
                      <ul class="uk-list vacancie-list">
                        <span>momenteel zijn er geen open vacatures</span>
                        <li
                          @click="activeVacancyID = item.id"
                          v-for="item in vacancies"
                          :key="item.id"
                        >
                          <span v-if="item.plek === 'kantoor'">{{item.title}}</span>
                          <span
                            v-if="item.plek === 'kantoor'"
                            class="icon uk-margin-left"
                            uk-icon="arrow-right"
                          ></span>
                        </li>
                      </ul>
                    </el-collapse-item>
                  </el-collapse> -->
                </div>
              </div>
              <div class="uk-width-1-2@m uk-width-1-1@s">
                <div
                  class="uk-animation-fade uk-padding"
                  style="border: 1px solid #dbdbdb"
                  :key="activeVacancyID"
                  v-if="activeVacancyID"
                >
                  <div class>
                    <h4 class="uk-text-center uk-text-uppercase">{{ vacancy.title }}</h4>
                    <p class="uk-text-center uk-text-uppercase">{{ vacancy.aanhef }}</p>

                    <p
                      v-for="(bodyPart, index) in vacancy.body"
                      :key="index"
                      class="uk-text-justify"
                    >
                      {{ bodyPart }}
                    </p>
                  </div>
                  <h4 class="uk-text-center uk-text-uppercase">wij zoeken:</h4>
                  <ul class="uk-list uk-list-bullet uk-padding-remove-top">
                    <li
                      class="uk-text-left"
                      v-for="item in vacancy['wij zoeken']"
                      :key="item"
                    >
                      {{ item }}
                    </li>
                  </ul>
                  <h4 class="uk-text-center uk-text-uppercase">wij bieden:</h4>
                  <ul class="uk-list uk-list-bullet uk-padding-remove-top">
                    <li
                      class="uk-text-left"
                      v-for="item in vacancy['wij bieden']"
                      :key="item"
                    >
                      {{ item }}
                    </li>
                  </ul>
                  <h3
                    class="uk-text-center uk-text-uppercase theme-color"
                    style="cursor: pointer"
                    @click="openVacancyModal(vacancy.title)"
                  >
                    reageer op deze vacature!
                    <span uk-icon="icon:arrow-right" />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VacatureModal :title="vacatureTitle" />
  </div>
</template>

<script>
import UIkit from 'uikit';
import vacatures from '../../public/vacatures';

import VacatureModal from '../components/VacatureModal.vue';

export default {
  components: {
    VacatureModal,
  },
  data() {
    return {
      activeVacancyID: 1,
      vacatureTitle: '',
    };
  },
  methods: {
    openVacancyModal(title) {
      this.vacatureTitle = title;
      UIkit.modal('#vacature-modal').show();
    },
  },
  computed: {
    vacancies: () => vacatures,
    vacancy() {
      return vacatures.find((vacature) => vacature.id === this.activeVacancyID);
    },
  },
};
</script>

<style lang="less">
@import "../assets/vars.less";

.el-collapse {
  border-top: none;
  border-bottom: none;
  color: #dbdbdb;
}

.el-collapse-item__header {
  display: flex;
  align-items: center;
  height: 48px;
  line-height: 48px;
  background-color: transparent;
  color: @primary-color;
  text-transform: uppercase;
  cursor: pointer;
  // border-bottom: 1px solid #ebeef5;
  border-bottom: none;
  font-size: 15px;
  font-weight: 500;
  transition: border-bottom-color 0.3s;
  outline: 0;
}

.el-collapse-item__wrap {
  will-change: height;
  background-color: transparent;
  overflow: hidden;
  box-sizing: border-box;
  border-bottom: none;
}

@media screen and (max-width: 600px) {
  .el-collapse-item__header {
    font-size: 11px;
  }
}
</style>

<style lang="less" scoped>
@import "../assets/vars.less";

.image-container {
  display: flex;
  justify-content: center;
  .wrapper {
    position: relative;
  }
  img {
    width: 100%;
    max-width: 100rem;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .text {
    background: rgba(104, 104, 104, 0.486);
    padding: 1rem;
    position: absolute;
    top: 3rem;
    left: 3rem;
    font-family: "Space Mono";
    font-size: 1.5rem;
    text-transform: uppercase;
    color: rgb(255, 255, 255);
    font-weight: 400;
  }
}

.theme-color {
  color: @primary-color;
}

.vacancie-list {
  li {
    text-align: left;
    cursor: pointer;
    font-size: 1rem;
    .icon {
      color: @primary-color;
    }
  }
}

// .card-container {
//   li {
//     // font-size: 1.2rem;
//     // font-family: "Space Mono";
//     text-transform: uppercase;
//     color: gray;
//   }
//   .icon {
//     color: @primary-color;
//     padding: 0 0.8rem;
//   }
//   .emphasis {
//     color: @primary-color;
//     font-family: "Space Mono";
//     text-transform: uppercase;
//   }
// }
</style>
